export class ObjectHelper {
  public static get<R = string>(object, path: string): R {
    const strings = path.split('.');
    return strings.reduce((previousObject = {}, key) => previousObject[key], object);
  }
}
